<script>
export default {
  name: 'TriggerWrapper',
};
</script>
<template>
  <router-view/>
</template>



// WEBPACK FOOTER //
// src/pages/triggers/TriggerWrapper.vue